import { DashboardActions } from "./dashboardActions";
import { useDashboardErrorHandlers } from "./dashboardErrorHandlers";
import { useDashboardHandlers } from "./dashboardHandlers";
import { DashboardState } from "./dashboardState";

export const useCombinedDashboardFeatureHandlers = (
    state: DashboardState,
    actions: DashboardActions
) => {
    useDashboardErrorHandlers(state, actions);
    useDashboardHandlers(state, actions);
};
